import { makeRequest } from 'utils/requestLogger';

export default (id, text, roundtable_type) =>
  makeRequest('post', `/api/courses/${id}/saved-feedback`, {
    text,
    roundtable_type,
  });



// WEBPACK FOOTER //
// ./src/app/services/courses/saveFeedback.js